<div class="init-load">
    <app-loading [loadingId]="'map'"></app-loading>
</div>
<div class="ol-map" [ngClass]="{'disabled-map': disabledMap}" id="{{ mapId }}"></div>
